module.exports = __webpack_public_path__ + "img/three-dots.291762ba.svg";